import { Box, Stack } from '@mui/material'
import { Outlet } from 'react-router-dom'

import SideMenu from '../ui/SideMenu'
import AppNavbar from '../ui/AppNavbar'
import Header from '../ui/Header'

function Dashboard() {
  return (
    <Box sx={{ display: 'flex' }}>
      <SideMenu />
      <AppNavbar />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          backgroundColor: '#FCFCFC',
          minHeight: '100vh',
          overflow: 'auto'
        }}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 }
          }}
        >
          <Header />
          <Outlet />
        </Stack>
      </Box>
    </Box>
  )
}

export default Dashboard
